import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "catalog-page" }
const _hoisted_2 = { class: "catalog-page__header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "catalog-filter__tab-special-label" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "catalog-page__product" }

import { ref, onMounted, watch } from 'vue';
import { Category, Product } from '@/types/app';
import ApiRepository from '@/repositories/api';
import AppHeader from '@/components/AppHeader.vue';
import AppTabs from '@/components/AppTabs.vue';
import AppTab from '@/components/AppTab.vue';
import BottomBtn from '@/components/BottomBtn.vue';
import ProductsList from '@/components/ProductsList.vue';
import useProductsStore from '@/store/products';
import IconPercent from '@/icons/icon-percent.vue';
import AppBtn from '@/components/AppBtn.vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogPage',
  setup(__props) {

const products = ref<Product[] | undefined>();
const productsFiltered = ref<Product[]>([]);
const isLoadingProducts = ref(true);
const search = ref('');
const productsFilter = {
  special: false,
  category: null as Category|null,
  search: '',
};
const isShowedProduct = ref<boolean>(false);
const route = useRoute();

const filterProducts = () => {
  productsFiltered.value = products.value || [];
  if (productsFilter.category) {
    productsFiltered.value = productsFiltered.value
      .filter((e: Product) => e.categoriesIds.indexOf(productsFilter.category!.categoryId) !== -1);
  }
  if (productsFilter.special) {
    productsFiltered.value = productsFiltered.value.filter((e: Product) => e.special);
  }
  if (productsFilter.search) {
    productsFiltered.value = productsFiltered.value
      .filter((e: Product) => e.name.search(new RegExp(productsFilter.search, 'i')) !== -1);
  }
};

const showAllProducts = () => {
  productsFilter.special = false;
  productsFilter.category = null;
  filterProducts();
};

const showSpecialProducts = () => {
  productsFilter.special = true;
  productsFilter.category = null;
  filterProducts();
};

const showCategoryProducts = (category: Category) => {
  productsFilter.special = false;
  productsFilter.category = category;
  filterProducts();
};

const searchProducts = () => {
  productsFilter.search = search.value;
  filterProducts();
};

const productsStore = useProductsStore();

const loadProducts = async () => {
  isLoadingProducts.value = true;
  if (!productsStore.isProductsLoaded) {
    await productsStore.loadProducts();
  }
  products.value = productsStore.products;
  isLoadingProducts.value = false;
  showAllProducts();
};

const categories = ref<Category[]|undefined>();
const isLoadingCategories = ref(true);
const loadCategories = async () => {
  isLoadingCategories.value = true;
  const response = await ApiRepository.fetchCategories();
  categories.value = response.data;
  isLoadingCategories.value = false;
};

const onFilterChanged = (val: number) => {
  if (val === 0) {
    showAllProducts();
  } else if (val === 1) {
    showSpecialProducts();
  } else {
    const category: Category|undefined = (categories.value || [])[val - 2];
    if (category) showCategoryProducts(category);
  }
};

watch(search, searchProducts);
watch(route, (value, oldValue, onCleanup) => {
  isShowedProduct.value = value.name === 'product';
  if (isShowedProduct.value) {
    document.body.classList.add('no-scroll');
  } else {
    document.body.classList.remove('no-scroll');
  }
});

onMounted(() => {
  loadProducts();
  loadCategories();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppHeader, {
        search: search.value,
        "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        searchModifiers: { trim: true }
      }, null, 8, ["search"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppTabs, {
          "onUpdate:modelValue": onFilterChanged,
          class: "catalog-filter"
        }, {
          default: _withCtx(() => [
            _createVNode(AppTab, { class: "catalog-filter__tab" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('all')), 1)
              ]),
              _: 1
            }),
            _createVNode(AppTab, {
              class: "catalog-filter__tab catalog-filter__tab--special",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(IconPercent)
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('stocks')), 1)
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
              return (_openBlock(), _createBlock(AppTab, {
                key: category.categoryId,
                class: "catalog-filter__tab"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(category.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(ProductsList, {
        "is-loading": isLoadingProducts.value,
        products: productsFiltered.value
      }, null, 8, ["is-loading", "products"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(BottomBtn)
  ]))
}
}

})